export default __webpack_public_path__ + "static/media/stephanie-krist.f7fd0a92.jpg";